export const addPxToNumber = <T extends number | `${number}`>(number: T): `${T}px` => `${number}px`
